import React, { useEffect, useState } from 'react';
const INITIAL_SECONDS = 15 * 60;
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('bio_urgency_timer');
    if (saved) {
      const remaining = parseInt(saved, 10);
      return remaining > 0 ? remaining : 0;
    }
    return INITIAL_SECONDS;
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const next = prev > 0 ? prev - 1 : 0;
        sessionStorage.setItem('bio_urgency_timer', String(next));
        return next;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="animate-slide-down bg-gradient-to-r from-[#8b0000] via-[#c82333] to-[#8b0000] text-white py-2 md:py-2.5 px-4 text-center relative z-[70] shadow-lg border-b border-red-900/50" data-id="element-214">
      <div className="max-w-2xl mx-auto" data-id="element-215">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3" data-id="element-216">
          <span className="text-white text-sm md:text-base tracking-[0.12em] uppercase font-bold leading-tight" style={{
          fontFamily: "'Cormorant Garamond', serif"
        }} data-id="element-217">
            🔥 CUPOS LIMITADOS
          </span>
          <div className="flex items-center gap-1" data-id="element-218">
            <span className="bg-white/20 backdrop-blur-sm text-white px-2 py-1 rounded-md text-lg md:text-xl font-extrabold tracking-widest leading-none border border-white/20" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.12em'
          }} data-id="element-219">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-white/80 text-base font-bold animate-pulse" data-id="element-220">
              :
            </span>
            <span className="bg-white/20 backdrop-blur-sm text-white px-2 py-1 rounded-md text-lg md:text-xl font-extrabold tracking-widest leading-none border border-white/20" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.12em'
          }} data-id="element-221">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-white/80 text-base font-bold animate-pulse" data-id="element-222">
              :
            </span>
            <span className="bg-white/20 backdrop-blur-sm text-white px-2 py-1 rounded-md text-lg md:text-xl font-extrabold tracking-widest leading-none border border-white/20" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.12em'
          }} data-id="element-223">
              {String(seconds).padStart(2, '0')}
            </span>
          </div>
        </div>
      </div>
    </div>;
}